/** @jsx jsx */
import _ from "lodash";
import { MDBBadge } from "mdbreact";
import { lighten } from "polished";
import { css, jsx } from "@emotion/core";
import { useTheme } from "emotion-theming";

const BadgePill = ({ themeColor, lightenColor, additionalProps, children }) => {
  const theme = useTheme();

  // Resolve a named theme color first; otherwise treat themeColor as a literal color value
  // (e.g. a hex like "#482d34"). Falls back to primary when nothing usable is provided.
  const resolvedColor =
    theme.colors[themeColor] || themeColor || theme.colors.primary;

  const bigBadge = css`
    display: block;
    padding: 0.5rem 1rem;
    margin-bottom: 0;
    text-transform: uppercase;
    background-color: ${resolvedColor} !important;
  `;

  const bigBadgeLighten = lightenColor
    ? css`
        background-color: ${lighten(lightenColor, resolvedColor)} !important;
      `
    : "";

  const handleBadgeLinkHover = () => {
    if (lightenColor) {
      return `&:hover {
        background-color: ${lighten(lightenColor + 0.1, resolvedColor)} !important;
      }`;
    }
    return "";
  };

  const bigBadgeLink =
    additionalProps && additionalProps.onClick
      ? css`
          cursor: pointer;
          ${handleBadgeLinkHover()};
        `
      : "";

  return (
    <MDBBadge
      pill
      className="mr-2"
      css={_.concat(bigBadge, bigBadgeLighten, bigBadgeLink)}
      {...additionalProps}
    >
      {children}
    </MDBBadge>
  );
};

export default BadgePill;
